import { VStack } from '@chakra-ui/react';
import { QRCodeCanvas } from 'qrcode.react';

interface QrCodeValidProps {
  idToEncode: string;
}

export const QrCodeValid = ({ idToEncode }: QrCodeValidProps) => {
  return (
    <VStack>
      <QRCodeCanvas
        value={idToEncode}
        size={200}
        bgColor='#ffffff'
        fgColor='#000000'
        marginSize={2}
        style={{ maxWidth: '100%' }}
      />
    </VStack>
  );
};
